module.exports = __webpack_public_path__ + "static/media/hrAssistant.23314548.png";